import {
  addBindingsToStringValue,
  removeBindingsFromStringValue,
} from "../../ControlFlow/utils";
import { BaseTemplate } from "./BaseTemplate";
import { ControlFlowFormComponentType } from "./FormTemplateTypes";
import type { BaseTemplateField } from "./BaseTemplate";
import type { ControlFlowFormItem } from "./FormTemplateTypes";
import type {
  SendControl,
  SendControlBlock,
} from "store/slices/apisV2/control-flow/types";

export default class SendTemplate extends BaseTemplate<SendControlBlock> {
  private getConfig(): Readonly<SendControl> {
    return this.source.config;
  }

  messageField(): BaseTemplateField<SendControlBlock, string> {
    const currentConfig = this.getConfig();
    const fieldValue = removeBindingsFromStringValue(currentConfig.message);

    const updateValue = (block: SendControlBlock, newValue: string) => {
      block.config.message = addBindingsToStringValue(newValue);
    };

    const formItem: ControlFlowFormItem = {
      ...this.getBaseFormItem(),
      label: "Message to send",
      componentType: ControlFlowFormComponentType.EXPRESSION_EDITOR,
    };

    return {
      formItem,
      fieldValue,
      updateValue,
      apiPbPaths: ["send.message"],
    };
  }

  computeFields() {
    return {
      message: this.messageField(),
    };
  }
}
